import React, { useEffect, useState } from "react";
import { WhyABScroller } from "./WhyABScroller";

export default function WhyAB(props: any) {
  return (
    <>
      {/* Why AB */}
      <div>
        {/* Web Design */}
        <div className=" lg:flex mt-4 lg:mt-20 py-[42px] lg:py-[50px]">
          <div className="w-full pl-4 lg:pl-customPadding 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
            <p className="font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[59px] text-brand-textBlack">
              WHY AUCTION BAZAAR?
            </p>
            <p className="pr-4 lg:pr-[360px] font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-5 lg:leading-[25px] text-brand-textGrey mt-3 lg:mt-[30px]">
              Choosing AuctionBazaar.com means choosing a platform that
              understands the intricacies of NPA auctions, provides the tools
              and support needed for successful property investments, and
              ensures that all legal aspects are thoroughly vetted
            </p>
            {/* <div className="mt-14"> */}
            <WhyABScroller className="mt-9 lg:mt-14 custom-scrollbar lg:scrollbar-hide" />
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
